import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { setErrorAction } from "../store/reducers/commonSlice";
import { AuthService } from "../services/AuthService";
import endpoints from "../endpoints";
import IPage from "../types/page";
import IFeature from "../types/feature";
import IView from "../types/view";

type TUpdateRequest = {
  [key: string]: any;
};

export const featureAPI = createApi({
  reducerPath: "featureAPI",
  baseQuery: fetchBaseQuery({
    baseUrl: `${endpoints.api}/options`,
    prepareHeaders: (headers: Headers) => {
      const token = AuthService.getToken() || "";
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
    },
  }),
  endpoints: (builder) => ({
    getAll: builder.mutation<TUpdateRequest, void>({
      query: () => {
        return {
          url: "",
          method: "GET",
        };
      },
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          const { data: result, meta } = await queryFulfilled;
        } catch (e: any) {
          if (e.error?.status === 401) {
            window.location.href = "/login";
          } else {
            dispatch(
              setErrorAction(e.error?.data?.message || "Options fetching error")
            );
          }
        }
      },
      transformResponse: (response: IFeature[]) => {
        if (!response) {
          return [];
        }

        return response.reduce((accum: TUpdateRequest, cur: any) => {
          accum[cur.name] = cur.value;
          return accum;
        }, {} as TUpdateRequest);
      },
    }),

    update: builder.mutation<void, TUpdateRequest>({
      query: (features) => {
        const formData: any = new FormData();
        for (let key in features) {
          if (features.hasOwnProperty(key)) {
            formData.append(key, features[key]);
          }
        }

        return {
          url: "",
          method: "PUT",
          body: formData,
        };
      },
    }),

    download: builder.mutation<any, string>({
      query: (filename) => {
        return {
          url: `/file/${filename}`,
          method: "GET",
          responseHandler: async (response) =>
            window.location.assign(
              window.URL.createObjectURL(await response.blob())
            ),
          cache: "no-cache",
        };
      },
    }),
  }),
});
